import { useEffect, useRef, useState } from "react";

// Shared px/second speed so every landing marquee moves at the exact same pace.
export const MARQUEE_SPEED = 42; // pixels per second — slightly slower for a perfectly smooth feel

// Infinite, seamless horizontal marquee. Duplicates items and sets the CSS
// animation duration from the measured pixel width => constant px/sec speed
// regardless of content length. Continuous, no visible loop seam.
export const Marquee = ({ items, renderItem, className = "", speed = MARQUEE_SPEED, paused = false }) => {
  const trackRef = useRef(null);
  const [dur, setDur] = useState(20);

  useEffect(() => {
    const el = trackRef.current;
    if (!el) return;
    const measure = () => {
      const half = el.scrollWidth / 2; // width of one (duplicated) set
      if (half > 0) setDur(half / speed);
    };
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, [items, speed]);

  const doubled = [...items, ...items];
  return (
    <div className={`marquee-mask overflow-hidden ${className}`}>
      <div ref={trackRef} className="flex w-max marquee-track" style={{ animationDuration: `${dur}s`, animationPlayState: paused ? "paused" : "running" }}>
        {doubled.map((it, i) => (
          <div key={i} className="shrink-0" aria-hidden={i >= items.length}>
            {renderItem(it, i % items.length)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
